import { useSharedState } from "composables/useSharedState";
import { useUidAttribute } from "composables/useUidAttribute";
import { tableCellVariants } from "./Table.styles";
import type { TableCellProps } from "./TableCellProps";

export interface UseTableCellOptions {
  props: Readonly<TableCellProps>;
}

export const useTableCell = (options: UseTableCellOptions) => {
  const { props } = options;
  useUidAttribute();
  useSharedState(props);
  const classes = tableCellVariants(props);
  return { classes };
};
